<sl-well>
<sl-list lines="full" (valueChange)="select($any($event).detail)">
    <sl-list-item *ngFor="let system of systems" [value]="system.id">
        <sl-label class="m-6" size="large">{{system.name}}</sl-label>
    </sl-list-item>
</sl-list>
</sl-well>
<sl-divider></sl-divider>
<div class="text-right">
    <sl-button (click)="close()" i18n>Cancel</sl-button>
</div>